module.exports = __webpack_public_path__ + "static/media/avatar.06dbc5f2.jpg";